export default __webpack_public_path__ + "static/media/MTL-Gazette.1c9df0c5.png";